import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";

import "./styles/global.css";

import ErrorBoundary from "./components/ErrorBoundary";
import { InternetStatusProvider } from "./context/InternetStatusContext";
import LoadingSpinner from "./components/LoadingSpinner";
import BackgroundGlow from "./components/BackgroundGlow";
import { MusicPlayerProvider } from "./context/MusicPlayerContext";
import { GameProvider } from "./context/GameContext";
import { UnifiedVideoProvider } from "./context/UnifiedVideoContext";

import GlobalMusicPlayer from "./components/GlobalMusicPlayer";

import { StoryProvider } from "./components/stories/StoryContext";

const AppRoutes = React.lazy(
  () => import("./routes/AppRoutes")
);

function App() {
  return (
    <InternetStatusProvider>
      <MusicPlayerProvider>
        <UnifiedVideoProvider>
          <GameProvider>
            <ErrorBoundary>
              <BrowserRouter>
                <StoryProvider>
                  <BackgroundGlow />

                  <Suspense
                    fallback={
                      <LoadingSpinner />
                    }
                  >
                    <AppRoutes />
                  </Suspense>

                  <GlobalMusicPlayer />

                  
                </StoryProvider>
              </BrowserRouter>
            </ErrorBoundary>
          </GameProvider>
        </UnifiedVideoProvider>
      </MusicPlayerProvider>
    </InternetStatusProvider>
  );
}

export default App;
